import React from "react";
import "./index.css";
import { siteContent } from "../content";

const UbicacionProyecto = () => {
    return (
        <div className="section ubicacionProyecto">
            <div className="container-lg flex flexRow mapaCols">
                <div className="mapa">
                    <iframe
                        src="https://www.google.com/maps/embed?pb=!1m17!1m12!1m3!1d3693.5937825332903!2d-57.57877409637133!3d-38.07736460386588!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m2!1m1!2s!5e1!3m2!1ses!2sar!4v1772555638082!5m2!1ses!2sar"
                        width="600"
                        height="450"
                        style={{ border: 0 }}
                        allowFullScreen=""
                        loading="lazy"
                        title="Ubicación del Proyecto"
                    ></iframe>


                </div>
                <div className="texto">
                    <h5>{siteContent.location.eyebrow}</h5>
                    <h2 className="titleSec">{siteContent.location.title}</h2>
                    <p>
                        {siteContent.location.description}
                    </p>
                </div>
            </div>
        </div>
    );
};

export default UbicacionProyecto;
